<div *ngIf="isShowComponent && currentUserInfo?.accesslevel =='ADMIN'" class="update-subscription-date">
    <label for="startDate">{{isEnableUpdate? 'Change' : 'Old' }} start date:</label>
    <input type="date" id="startDate" name="startDate" [disabled]="!isEnableUpdate" [min]="minDate" [max]="maxDate"
        [(ngModel)]="oldStartDate">
    <button (click)="updateStartDate()" *ngIf="isEnableUpdate" class="btn btn-primary">Update Start Date</button>
</div>